import { render } from "./pairing-preview.vue?vue&type=template&id=3268b8ce&lang=pug"
import script from "./pairing-preview.vue?vue&type=script&lang=js"
export * from "./pairing-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__